import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    approvedByUserName?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetApprovedByUserNameValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { approvedByUserName } = this.props;
        if (!approvedByUserName) {
            return null;
        }
        return approvedByUserName;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    approvedByUserName: makeSelectTimesheetValue('approvedByUserName')
});

export default connect(mapStateToProps)(TimesheetApprovedByUserNameValue);
